import React from "react";
import {
    Grid,
    Typography
} from '@mui/material';
import GuestAnswersForm from "./components/GuestAnswersForm";


const GuestAnswers: React.FC = () => {
    return (
        <>

            <Typography variant="h4" gutterBottom sx={{mb: 4}} >
                RSVP
            </Typography>
            <Grid container sx={{flexDirection: "column",}}>
                <GuestAnswersForm/>
            </Grid>


        </>
    );
};

export default GuestAnswers;